import { render, staticRenderFns } from "./BlockFeedback.vue?vue&type=template&id=4323f502&scoped=true&"
import script from "./BlockFeedback.vue?vue&type=script&lang=ts&"
export * from "./BlockFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./BlockFeedback.vue?vue&type=style&index=0&id=4323f502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323f502",
  null
  
)

export default component.exports